import RidersPage from '../RidersPage';

const PastRiderList = () => {
  return <RidersPage />;
};

export default PastRiderList;
